import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import ERROR from '../../../assets/images/base/cancel.png';
import { Page } from '../../../helbest';

const BankCancel = ({ Login, history }) => {
  const check_user = () => {
    if (!Login.is_login) {
      history.push('/');
    }
  };

  useEffect(() => {
    check_user();
  }, []); // eslint-disable-line

  return (
    <Page
      address="/"
      back={true}
      className="page-bank"
      headerFix
      logo
      mobileContainer
      showFooter
      title="نتیجه پرداخت">
      <div className="container desktop-mode">
        <div className="box-page">
          <div className="text-center">
            <img alt="" className="payment-img" src={ERROR} />
            <h3>پرداخت توسط شما لغو شد</h3>
          </div>
          <div>
            <p>شما می‌توانید با مراجعه به سبد خرید خود، مجددا نسبت به پرداخت سفارش اقدام کنید.</p>
          </div>
          <Link className="mt-2 btn btn-block btn-round btn-red" to="/cart/">
            سبد خرید
          </Link>
        </div>
      </div>
    </Page>
  );
};

const mstp = (state) => ({
  Login: state.Login,
  Cart: state.Cart
});
export default connect(mstp)(BankCancel);
